import { defineMessages, MessageDescriptor } from 'react-intl';

import { SessionKind } from '@/shared/api/protocol-ts/api/auth/dto_auth_pb';

export const sessionKindLabels: Partial<
  Record<SessionKind, MessageDescriptor>
> = defineMessages({
  [SessionKind.SessionKindSignIn]: {
    id: 'activeSessions.kind.signIn',
    defaultMessage: 'Sign-in',
  },
  [SessionKind.SessionKindPartnerAPI]: {
    id: 'activeSessions.kind.integration',
    defaultMessage: 'Integration',
  },
  [SessionKind.SessionKindPresign]: {
    id: 'activeSessions.kind.link',
    defaultMessage: 'Sign-in link',
  },
});
